import { useEffect, useRef } from 'react';
import { Editor } from '@meitu/saas-editor-core';
import { ImageLayer } from '@meitu/saas-editor-core/es/layers/image-layer';
import { LayerType } from '@meitu/saas-editor-core/es/version-types';
import { useListenActivePickLayerProps } from '@/hooks/use-listen-layer-props';

const useImageGlRenderClose = (editor: Editor) => {
    const originLayerId = useRef<string | null>();
    const id = useListenActivePickLayerProps(editor, (layer) => {
        if (!layer) return null;
        const { id } = layer;
        return id;
    });

    useEffect(() => {
        if (!originLayerId.current) {
            originLayerId.current = id;
            return;
        }
        const activeLayer = editor.stage.getLayer(originLayerId.current);

        if (!activeLayer) return;
        if (activeLayer.layerType !== LayerType.IMAGE_LAYER || originLayerId.current === id) {
            return;
        }

        editor.getInstance(ImageLayer).showImageEffectRenderState(originLayerId.current, false);
        originLayerId.current = id;
    }, [id]);
};

export default useImageGlRenderClose;
